export default class BodyScroll {
	constructor() {
		this.debounce_timer = null;
		this.events();
	}

	events() {
		window.addEventListener("scroll", function () {
			if (this.debounce_timer) {
				window.clearTimeout(this.debounce_timer);
			}
			this.debounce_timer = window.setTimeout(() => {
				if (window.innerWidth < 768) {
					document.body.classList.add("scrolled");
					return;
				}

				let pageYOffset = window.pageYOffset || document.body.scrollTop;

				if (10 < pageYOffset) {
					document.body.classList.add("scrolled");
				} else {
					document.body.classList.remove("scrolled");
				}
			}, 10);
		});

		window.dispatchEvent(new Event("scroll"));
	}
}
